<div class="modal-body">
  <div class="container">
    <div class="row">
      <div class="col-sm-10 col-10">
        <p class="modal-resume-text"><strong>Professional Resume</strong> Format</p>
      </div>
      <div class="col-sm-2 col-2">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss({})">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col-sm-8">
        <img src="../../../../../assets/images/resume/{{data.img}}" class="img-fluid" /></div>
      <div class="col-sm-4">
        <div class="resume__body">
          <p>This is professional free resume created and designed by the team at MyResumeFormat.</p>
          <p>&nbsp;</p>
          <!--<div class="row">
            <div class="col-sm-6">
              <button class="btn btn-sm btn-block btn-secondary">Prev</button>
            </div>
            <div class="col-sm-6">
              <button class="btn btn-sm btn-block btn-secondary">Next</button>
            </div>
          </div>
          <br />
          <button routerLink="/login/info" class="btn btn-block btn-primary">Select</button>-->
        </div>
      </div>
    </div>
  </div>
</div>
